
import { BASE_URL } from '@/common/constant';
import { ISPUImageUploadOptions } from '@/common/interface/spu';
import { $delay } from '@/common/utils';
import lazyInject from '@/di';
import SPUService from '@/services/spu.service';
import UserService from '@/services/user.service';
import ApplicableShopsPoi from '@/components/spu/ApplicableShopsPoi.vue';

import {
  Vue,
  Component,
  Prop,
  Watch,
  Ref,
  Model,
} from 'vue-property-decorator';
import { DebounceTime } from '@/common/decorator';

enum EInvalidIds {
  SUSPENDED_BIZ_IDS = 'suspendedBizIds',
  PERMANENT_BIZ_IDS = 'permanentBizIds',
  EXCEOPTION_IDS = 'exceptionIds ',
  NUM_ERROR_IDS = 'numErrorIds',
  ONSITE_ERROR = 'onsiteError',
  CREATE_NO_PASS = 'createNoPass',
  VIRTUAL_SHOP_ERROR = 'virtualShopError',

}

@Component({
  components: {
    ApplicableShopsPoi,
  },
})
export default class TempSpuShopPoiNewField extends Vue {
  BASE_URL = BASE_URL;

  token: string | undefined = undefined;

  options: ISPUImageUploadOptions = {
    allowDuplicateUploads: false,
    target: `${BASE_URL}/tool/upload`,
    testChunks: false,
    headers: {},
    chunkSize: 5 * 1024 * 1024,
  };

  val = '';

  spuLimit = 0;

  uploading = false;

  suspendedBizIds = '';

  permanentBizIds = '';

  exceptionIds = '';

  numErrorIds = '';

  onsiteError = '';

  createNoPass = '';

  virtualShopError = '';

  EInvalidIds = EInvalidIds;

  get suspendedBizStatus() {
    return this.suspendedBizIds !== '';
  }

  get exceptionIdsStatus() {
    return this.exceptionIds !== '';
  }

  get numErrorIdsStatus() {
    return this.numErrorIds !== '';
  }

  get permanentBizStatus() {
    return this.permanentBizIds !== '';
  }

  get getonsiteError() {
    return this.onsiteError !== '';
  }
  get createNoPassStatus() {
    return this.createNoPass !== '';
  }

  get virtualShopErrorStatus() {
    return this.virtualShopError !== '';
  }

  get uploadDisabled() {
    if (this.val !== '' || this.uploading === true || this.disabled === true) {
      return true;
    }
    return false;
  }

  get deltaBtnVisible() {
    if (this.val !== '') {
      return true;
    }
    return false;
  }

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  placeholder!: string;

  @Prop()
  spuType!: 'spu' | 'platformSpu' | 'kaSpu' | 'leadingSpu';

  @Prop()
  formData!: any;

  @Prop()
  form!: any;

  @Model('change', {
    type: String,
  })
  value!: string;

  @Ref()
  applicableShopsPoi!: ApplicableShopsPoi;

  @Watch('value')
  watchValue() {
    if (this.value !== undefined && this.val !== this.value) {
      this.val = this.value;
    }
  }

  @lazyInject(UserService)
  userService!: UserService;

  @lazyInject(SPUService)
  spuService!: SPUService;

  reset() {
    this.val = '';
    this.uploading = false;
    this.suspendedBizIds = '';
    this.permanentBizIds = '';
    this.exceptionIds = '';
    this.numErrorIds = '';
    this.onsiteError = '';
    this.virtualShopError = '';
  }

  /** 一键移除 */
  async remove(invalidType: EInvalidIds) {
    const all = this.val.split(',').map((item) => {
      return item;
    });
    let diff: any[] = [];
    switch (invalidType) {
      case EInvalidIds.SUSPENDED_BIZ_IDS: {
        const suspendList = this.suspendedBizIds.split(',').map((item) => {
          return item;
        });
        diff = all.filter((item) => suspendList.indexOf(item) === -1);
        this.suspendedBizIds = '';
        break;
      }

      case EInvalidIds.PERMANENT_BIZ_IDS: {
        const permanentList = this.permanentBizIds.split(',').map((item) => {
          return item;
        });
        diff = all.filter((item) => permanentList.indexOf(item) === -1);
        this.permanentBizIds = '';
        break;
      }

      case EInvalidIds.NUM_ERROR_IDS: {
        const numErrorList = this.numErrorIds.split(',').map((item) => {
          return item;
        });
        diff = all.filter((item) => numErrorList.indexOf(item) === -1);
        this.numErrorIds = '';
        break;
      }
      case EInvalidIds.ONSITE_ERROR: {
        const onsiteErrorList = this.onsiteError
          .split(',')
          .map((item) => {
            return item;
          });
        diff = all.filter((item) => onsiteErrorList.indexOf(item) === -1);
        this.onsiteError = '';
        break;
      }
      case EInvalidIds.CREATE_NO_PASS: {
        const createNoPassList = this.createNoPass.split(',').map((item) => {
          return item;
        });
        diff = all.filter((item) => createNoPassList.indexOf(item) === -1);
        this.createNoPass = '';
        break;
      }
      case EInvalidIds.VIRTUAL_SHOP_ERROR: {
        const virtualShopErrorList = this.virtualShopError.split(',').map((item) => {
          return item;
        });
        diff = all.filter((item) => virtualShopErrorList.indexOf(item) === -1);
        this.virtualShopError = '';
        break;
      }

      default: {
        const exceptionList = this.exceptionIds.split(',').map((item) => {
          return item;
        });
        diff = all.filter((item) => exceptionList.indexOf(item) === -1);
        this.exceptionIds = '';
        break;
      }
    }

    this.val = diff.join(',');
    this.$message.success('移除成功');
    this.onChange();
  }

  isLt5M(file: File) {
    return file.size / 1024 / 1024 < 5;
  }

  /** 校验门店 */
  public async checkShop(): Promise<boolean> {
    const res = await this.handleShopIdsSave(this.val) as any;
    if (res) {
      const { error, forever, stop, num_error, onsite_error, create_no_pass, virtual_shop_error } = res;
      if (create_no_pass) {
        this.createNoPass = create_no_pass;
      }
      if (error) {
        this.$message.error('门店校验异常');
        return error === '';
      } else if (forever) {
        this.$message.error('门店校验异常');
        return forever === '';
      } else if (num_error) {
        this.$message.error('门店校验异常');
        return num_error === '';
      } else if (onsite_error) {
        this.$message.error('门店校验异常');
        return onsite_error === '';
      } else if (stop) {
        this.$message.error('门店校验异常');
        return stop === '';
      } else if (virtual_shop_error) {
        this.$message.error('门店校验异常');
        return virtual_shop_error === '';
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  public async getCreateNoPass(): Promise<boolean> {
    console.log('jianyan', this.createNoPass !== '', this.createNoPass);
    return this.createNoPass !== '';
  }

  beforeUpload(file: { type: string; size: number }) {
    const isExcel =
      file.type === 'application/vnd.ms-excel' ||
      file.type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'text/csv';
    if (!isExcel) {
      this.$message.error('请上传 excel表格！');
    }
    const isLt5M = this.isLt5M(file as File);
    if (!isLt5M) {
      this.$message.error('文件必须小于5MB!');
    }
    return isExcel && isLt5M;
  }

  /** 全量SHOP_ID导入 */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onFullImportChange(info: any) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      const { error, stop, forever, num_error, onsite_error, create_no_pass, virtual_shop_error } = data;
      const all = data.data;
      this.suspendedBizIds = '';
      this.permanentBizIds = '';
      this.exceptionIds = '';
      this.numErrorIds = '';
      this.onsiteError = '';
      this.createNoPass = '';
      this.virtualShopError = '';
      if (stop) {
        this.suspendedBizIds = stop;
      }
      if (forever) {
        this.permanentBizIds = forever;
      }
      if (error) {
        this.exceptionIds = error;
      }
      if (num_error) {
        this.numErrorIds = num_error;
      }
      if (onsite_error) {
        this.onsiteError = onsite_error;
      }
      if (create_no_pass) {
        this.createNoPass = create_no_pass;
      }
      if (virtual_shop_error) {
        this.virtualShopError = virtual_shop_error;
      }
      this.val = all;
      this.uploading = false;
      this.onChange();
    }
  }

  /** 增量SHOP_ID导入 */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onDeltaImportChange(info: any) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      const { error, stop, forever, num_error, onsite_error, create_no_pass, virtual_shop_error } = data;
      const newIds = data.data;
      const ids = this.val.split(',').concat(newIds.split(',')).filter(Boolean);
      const _ids = [...new Set([...ids])];
      this.suspendedBizIds = '';
      this.permanentBizIds = '';
      this.exceptionIds = '';
      this.numErrorIds = '';
      this.onsiteError = '';
      this.createNoPass = '';
      this.virtualShopError = '';
      if (virtual_shop_error) {
        this.virtualShopError = virtual_shop_error;
      }
      if (stop) {
        this.suspendedBizIds = stop;
      }
      if (forever) {
        this.permanentBizIds = forever;
      }
      if (error) {
        this.exceptionIds = error;
      }
      if (num_error) {
        this.numErrorIds = num_error;
      }
      if (onsite_error) {
        this.onsiteError = onsite_error;
      }
      if (create_no_pass) {
        this.createNoPass = create_no_pass;
      }
      this.val = _ids.join(',');
      this.uploading = false;
      this.onChange();
    }
  }

  async checkShopIds(val: string) {
    const data = {
      pois: val,
      scid: this.formData.category.id,
      // multi: this.formData.multi,
    };
    // console.log(data);
    return this.spuService.spuCheckShopIds(data);
  }

  async handleShopIdsSave(val: string) {
    this.val = val;
    if (val === '') {
      return;
    }
    const res: any = await this.checkShopIds(val);
    if (res) {
      if (res.error) {
        this.exceptionIds = res.error;
      }
      if (res.forever) {
        this.permanentBizIds = res.forever;
      }
      if (res.stop) {
        this.suspendedBizIds = res.stop;
      }
      if (res.num_error) {
        this.numErrorIds = res.num_error;
      }
      if (res.onsite_error) {
        this.onsiteError = res.onsite_error;
      }
      if (res.create_no_pass) {
        this.createNoPass = res.create_no_pass;
      }
      if (res.virtual_shop_error) {
        this.virtualShopError = res.virtual_shop_error;
      }
    }

    this.onChange();
    return res;
  }

  async onBlur(val: string) {
    await this.handleShopIdsSave(val);
  }

  openShopListModal() {
    // console.log(this.formData);
    this.applicableShopsPoi.open();
  }

  onCopySuccess() {
    this.$message.success('复制成功');
  }

  @DebounceTime(320)
  onChange() {
    this.$emit('change', this.val);
  }

  mounted() {
    this.watchValue();
    this.getRule('store_spu_online_limit');
  }
  async getRule(key: string) {
    const res = await this.spuService.getRule(key);
    if (res) {
      this.spuLimit = res;
    }
  }
  created() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }
}
